module.exports = __webpack_public_path__ + "assets/img/d62cbcb13a51005296db14566ba4f41f.svg";